/**
 * This module defines a collection of static general utility functions.
 */

// TODO: This should be set from somewhere else (probably as a param to controller like before; but then I need to make this updatable)
const isInDevMode = true;

const _util = {
  isInDevMode: isInDevMode
};

export {
  _util,
};
